var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlexibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.664 8.183a1 1 0 0 1-1.002-1.002 1 1 0 0 1 1.002-1.002h.334A1 1 0 0 1 16 7.18a1 1 0 0 1-1.002 1.002h-.334Z",
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.982 8.851h3.007v3.675c0 .738.598 1.336 1.336 1.336V.5c-.738 0-1.336.598-1.336 1.336v3.675H7.57c-1.58 0-3.013.929-3.658 2.368L1.124 14.1a1.425 1.425 0 0 0 .511 1.768l2.853-4.995A4.007 4.007 0 0 1 6.833 9.02",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.982 8.851h3.007v3.675c0 .738.598 1.336 1.336 1.336V.5c-.738 0-1.336.598-1.336 1.336v3.675H7.57c-1.58 0-3.013.929-3.658 2.368L1.124 14.1a1.425 1.425 0 0 0 .511 1.768l2.853-4.995A4.007 4.007 0 0 1 6.833 9.02",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.945 9.403 3.203 5.87c.291.537.926.788 1.507.594L7.983 8.852V7.85",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5.945 9.403 3.203 5.87c.291.537.926.788 1.507.594L7.983 8.852V7.85M7.983 7.181v-1.67",
    stroke: "#000",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibility);
export default __webpack_public_path__ + "static/media/flexibility.a1ce61197d725920aac2da5552e77ad5.svg";
export { ForwardRef as ReactComponent };